import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AllEmployeeAddPopup from "../../../components/modelpopup/AllEmployeeAddPopup";
import Breadcrumbs from "../../../components/Breadcrumbs";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import EmployeeListFilter from "../../../components/EmployeeListFilter";
import PersonProfileView from "../../specificProfile";
// import { Table as AntTable } from 'antd';
import { Table } from "antd";
import { Navbar, Button, Table as BootstrapTable } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./data.css";
import Kashis from "./kashis";
import ProgressIndicator from "./ProgressIndicator";
import EmployeeLeave from "./Table";
import Papa from "papaparse";
import ReadingTable from "./readingTable2";
import Transform from "./TransformData";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

const AllEmployee = () => {
  const users = {
    REQ_TYPE: "hello",
  };

  const columns = [
    {
      title: "Request Type",
      dataIndex: "REQ_TYPE",
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => a.REQ_TYPE.length - b.REQ_TYPE.length,
    },

    // {
    //   title: "From",
    //   dataIndex: "REQ_FROM",
    //   render: (text) => <span>{moment(text).format("DD-MM-YYYY")}</span>,
    //   sorter: (a, b) => a.REQ_FROM.length - b.REQ_FROM.length,
    // },
    // {
    //   title: "To",
    //   dataIndex: "REQ_TO",
    //   render: (text) => <span>{moment(text).format("DD-MM-YYYY")}</span>,
    //   sorter: (a, b) => a.REQ_TO - b.REQ_TO,
    // },

    // {
    //   title: "No Of Days",
    //   dataIndex: "NO_DAYS",
    //   render: (text) => <span>{text}</span>,
    //   sorter: (a, b) => a.NO_DAYS.length - b.NO_DAYS.length,
    // },

    // {
    //   title: "Reason",
    //   dataIndex: "REASON",
    //   render: (text) => <span>{text}</span>,
    //   sorter: (a, b) => a.REASON.length - b.REASON.length,
    // },
  ];

  // const [fileData, setFileData] = useState(['test-sheet.csv', 'test-sheet2.csv', 'test-sheet3.csv', 'test-sheet4.csv', 'test-sheet5.csv']);
  const [csvDataTable1, setCsvDataTable1] = useState([]);
  const [csvDataTable2, setCsvDataTable2] = useState([]); // Stores the content of the selected CSV file
  const [filename1, setFilename1] = useState("READING_202301.csv");
  const [filename2, setFilename2] = useState("READING_202302.csv");
  const [firstRender, setFirstRender] = useState(false);
  const [secondRender, setSecondRender] = useState(true);
  const [filesData, setFilesData] = useState(["consumption_fewdata.csv"]);
  const [tsvData, setTsvData] = useState([]);
  const [secondTableData, setSecondTableData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  // const[csvData,setCsvData]=useState();

  const CELL_WIDTH = 165;
  useEffect(() => {
    const fetchAndParseCSV = async (filename, setCsvData, label) => {
      try {
        console.log(`Fetching ${label} from /csv-files/${filename}`); // Log the file path
        const response = await fetch(`/csv-files/${filename}`);
        const csvText = await response.text();
        Papa.parse(csvText, {
          header: true, // Parse CSV with headers
          skipEmptyLines: true, // Skip empty lines
          complete: (result) => {
            console.log(`${label} parsed data:`, result.data); // Log parsed data
            setCsvData(result.data); // Set the parsed data for display in the table
          },
          error: (error) => {
            console.error(`Error parsing ${label}:`, error);
          },
        });
      } catch (error) {
        console.error(`Error fetching ${label}:`, error);
      }
    };

    if (secondRender) {
      fetchAndParseCSV(filename1, setCsvDataTable1);
      fetchAndParseCSV(filename2, setCsvDataTable2);
      setSecondRender(false);
    }
    fetch("/all_data.csv")
      .then((response) => response.text()) // Get the CSV file as plain text
      .then((csvText) => {
        Papa.parse(csvText, {
          header: true,
          worker: true,
          complete: (result) => {
            console.log("fetch", result);
            if (result.data && result.data.length > 0) {
              // Filter the data to include only rows for account ID 7662453172

              // Second table: Filter rows where any 'out_*' column has a value of 7
              const outData = result.data.filter((row) => {
                return Object.keys(row).some(
                  (key) => key.startsWith("out") && row[key] === "2"
                );
              });

              // Map 'out_*' data and remove 'CONS_' prefix from column headers
              const mappedOutData = outData.map((row) => {
                const cleanedRow = {};
                let clusterValue = ""; // To store the corresponding cluster value

                Object.entries(row).forEach(([key, value]) => {
                  // Capture 'out_*' column values to display in the 'Cluster' column
                  if (key.startsWith("out")) {
                    clusterValue += ` ${value} `;
                  }
                  // Remove 'CONS_' prefix from other columns
                  cleanedRow[
                    key.startsWith("CONS_") ? key.replace("CONS_", "") : key
                  ] = value;
                });

                // Modify the 'dist' column to be shown as 'deviation' with values multiplied by 100
                if (cleanedRow["deviation_percentage"]) {
                  cleanedRow["deviation"] = parseFloat(
                    cleanedRow["deviation_percentage"]
                  ).toFixed(2);
                } else {
                  cleanedRow["deviation"] = ""; // Add an empty string if 'dist' is undefined
                }

                return { ...cleanedRow, Cluster: clusterValue.trim() }; // Add the concatenated cluster values
              });
              const limitedData = mappedOutData.slice(0, 1000);
              setSecondTableData(limitedData); // Set the filtered and cleaned data for the second table
            }
          },
        });
      })
      .catch((error) => {
        console.error("Error fetching the CSV file:", error);
      });
  }, [secondRender, filename1, filename2]);
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
    const sortedData = [...secondTableData].sort((a, b) => {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    });
    setSecondTableData(sortedData);
  };

  // Extract table headers for the second table, ensuring the first column is 'Cluster'
  const tableHeaders =
    secondTableData.length > 0
      ? [
          "AC_ID",

          ...Object.keys(secondTableData[0]).filter(
            (key) =>
              key !== "AC_ID" &&
              key !== "Cluster" &&
              key !== "deviation_percentage" &&
              key !== "out" &&
              key !== "dist" &&
              key !== "DIV" &&
              key !== "SUPPLY_TYPE" &&
              key !== "CATEGORY" &&
              key !== "GOVT_TAG" &&
              key !== "PROCESS" &&
              key !== "NAME" &&
              key !== "ADDRESS" &&
              key !== "SITE_PROCESS" &&
              key !== "CONTACT_DEMAND_KW" &&
              key !== "Unnamed: 0" &&
              key !== "deviation" &&
              key.trim() !== ""
          ),
        ]
      : [];
  const navigate = useNavigate();
  const handleTransformClick = async (e) => {
    console.log("inside handle", e);
    let allData = [];

    if (!firstRender) {
      console.log(`/csv-files/${filesData}`, `/csv-files/${e}`);
      const response = await fetch(`/csv-files/${e ? e : filesData}`);
      const csvText = await response.text();
      Papa.parse(csvText, {
        header: true, // Parse CSV with headers
        skipEmptyLines: true, // Skip empty lines
        complete: (result) => {
          allData = [...allData, ...result.data]; // Add parsed data to array
          setTsvData(allData); // Set the parsed data for display in the table
          console.log(allData);
        },
        error: (error) => {
          console.error("Error parsing CSV:", error);
        },
      });
    } else {
      // Handle multiple files upload logic here
    }
  };

  useEffect(() => {
    if (!firstRender) {
      handleTransformClick();
    }
  }, []);

  const handleNextStep = () => {
    navigate("/data-segmentation");
  };
  const handlePrevStep = () => {
    navigate("/cluster-creations");
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div>
            <ProgressIndicator />
          </div>

          <div className="flex row">
            <div className="col-6">
              <ReadingTable csvData={csvDataTable1} />
            </div>

            <div className="col-6">
              <Kashis csvData={csvDataTable2} />
            </div>
            <div className="text-center">
              <div
                className="file-import-container"
                style={{ position: "relative", display: "inline-block" }}
              >
                <button
                  className="btn btn-success btn-lg"
                  type="button"
                  style={{ width: "500px" }}
                  onClick={(e) => e.stopPropagation()} // Prevents button clicks from triggering file input
                >
                  <i
                    className="fas fa-file-import"
                    style={{ marginRight: "8px" }}
                  ></i>
                  Transform Data
                </button>
                <input
                  type="file"
                  multiple
                  accept=".csv"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    opacity: 0,
                    cursor: "pointer",
                  }}
                  onChange={(event) => {
                    setFirstRender(true);
                    const files = Array.from(event.target.files);
                    const fileList = files.map((file) => file.name);
                    setFilesData(fileList);
                  }}
                />
              </div>
            </div>
            <div
              class="card"
              style={{
                marginTop: "50px",
                marginLeft: "3px",
                marginRight: "1px",
                paddingRight: "50px",
                paddingLeft: "0px",
                paddingTop: "0px",
                paddingBottom: "100px",
              }}
            >
              {console.log("tsvDatatsvDatatsvData", tsvData)}
              {/* {tsvData && tsvData?.length > 0 && <EmployeeLeave tsvData={tsvData}/>} */}
              <div className="card-body">
                <h2 className=" mb-1">Consumption Table</h2>
                <div
                  className="table-responsive"
                  style={{
                    maxHeight: "400px", // Set a maximum height for the table container
                    overflowY: "auto", // Enable vertical scrolling within the table container
                    overflowX: "auto", // Enable horizontal scrolling if needed
                  }}
                >
                  {secondTableData.length > 0 ? (
                    <table
                      className="table table-bordered mb-0"
                      style={{ width: "100%", tableLayout: "fixed" }}
                    >
                      <thead>
                        <tr>
                          {tableHeaders.map((header, index) => (
                            <th
                              key={index}
                              style={{
                                width: `${CELL_WIDTH}px`,
                                whiteSpace: "nowrap",
                                backgroundColor: "#3651FB",
                                color: "whitesmoke",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                handleSort(
                                  header === "Deviation Percentage"
                                    ? "deviation"
                                    : header
                                )
                              } // Handle sorting on click
                            >
                              {header}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {secondTableData.map((row, rowIndex) => (
                          <tr key={rowIndex}>
                            {tableHeaders.map((header, colIndex) => (
                              <td
                                key={colIndex}
                                style={{
                                  width: `${CELL_WIDTH}px`,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {header === "Deviation Percentage" &&
                                row["deviation"] ? (
                                  `${row["deviation"]}%`
                                ) : (
                                  <>
                                    {header === "AC_ID" && row["AC_ID"] ? (
                                      <Link
                                        // className="dropdown-item"
                                        to="#"
                                        data-bs-toggle="modal"
                                        // data-bs-backdrop="static"
                                        aria-labelledby="delete"
                                        aria-hidden="true"
                                        // data-bs-target="#edit_leave"
                                        data-bs-target="#delete"
                                      >
                                        {row["AC_ID"]}
                                      </Link>
                                    ) : (
                                      row[header]
                                    )}
                                  </>
                                )}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div className="text-center">
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* <div>
                {
                  <Table
                  // rowKey={(record) => record.id}
                  scroll={{ y: 300 }}
                    columns={columns}
                  
                  dataSource={
                      users
                  }
                  className="table-striped"
                />
                }
      </div> */}
            <div className="footer">
              {" "}
              <button className="prev-button" onClick={handlePrevStep}>
                <FaArrowLeft style={{ marginRight: "8px" }} /> Previous Step
              </button>
              <button className="next-button" onClick={handleNextStep}>
                Next Step <FaArrowRight style={{ marginLeft: "8px" }} />
              </button>
            </div>
          </div>
          {/* /Content End */}
        </div>
        {/* /Page Content */}
      </div>
    </>
  );
};
export default AllEmployee;
